import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Options = (props) => props.options.map((option) => {
  const { value, label } = typeof option === 'string'
    ? { value: option, label: option }
    : option;

  return (
    <option value={value} selected={value === props.selectValue}>
      {label}
    </option>
  );
});

Options.propTypes = {
  options: PropTypes.instanceOf(Array).isRequired,
};

const Select = (props) => {
  const {
    includeBlank,
    onChange,
    options,
    value,
    transparent,
    name,
    className,
    disabled,
  } = props;

  const classNames = classnames('bvs-form-control', className, {
    'is-transparent': transparent,
  });

  return (
    <select
      className={classNames}
      onChange={onChange}
      name={name}
      disabled={disabled}
    >
      {includeBlank && <option value="">{includeBlank}</option>}
      {
        options instanceof Array
          ? <Options options={options} selectValue={value} />
          : Object.entries(options).map(([group, groupOptions]) => (
            <optgroup label={group}>
              <Options options={groupOptions} selectValue={value} />
            </optgroup>
          ))
      }
    </select>
  );
};

Select.propTypes = {
  includeBlank: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.instanceOf(Array).isRequired,
  value: PropTypes.string.isRequired,
  transparent: PropTypes.bool,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

Select.defaultProps = {
  transparent: false,
  className: null,
  disabled: false,
};

export default Select;
